<template>
  <div class="track view">
    <div class="tracktop">
      <div class="tracktopleft">
        <Steering_wheel :steering_angle="mainStore.getters.main('SteeringAngle')" />
      </div>
      <div class="tracktopcenter">Track</div>
      <div class="tracktopright">
        <Speedometer class="track_speedometer" :speed="mainStore.getters.main('VehicleSpeed')"
          :rpm="mainStore.getters.main('RPM')" :gear="mainStore.getters.main('Gear')" />
      </div>
    </div>
    <div class="trackbottom">
      <div class="trackbottomleft">
        <G-force :XCoord="mainStore.getters.main('AccelerationRight')"
          :YCoord="mainStore.getters.main('AccelerationForward')" />
      </div>
      <div class="trackbottomcenter">
        <div class="ttyretextl">
          <div class="tflt">
            Front left tyre
            <div class="tflts1">Sector1: {{ mainStore.getters.main('Tyre_Temp_FL1') }} °C</div>
            <div class="tflts2">Sector2: {{ mainStore.getters.main('Tyre_Temp_FL3') }} °C</div>
            <div class="tflts3">Sector3: {{ mainStore.getters.main('Tyre_Temp_FL5') }} °C</div>
            <div class="tflts4">Sector4: {{ mainStore.getters.main('Tyre_Temp_FL7') }} °C</div>
          </div>
          <div class="trlt">
            Rear left tyre
            <div class="trlts1">Sector1: {{ mainStore.getters.main('Tyre_Temp_RL1') }} °C</div>
            <div class="trlts2">Sector2: {{ mainStore.getters.main('Tyre_Temp_RL3') }} °C</div>
            <div class="trlts3">Sector3: {{ mainStore.getters.main('Tyre_Temp_RL5') }} °C</div>
            <div class="trlts4">Sector4: {{ mainStore.getters.main('Tyre_Temp_RL7') }} °C</div>
          </div>
        </div>

        <div class="tyre-container">
          <div class="tyres">
            <TrackTyre class="tfl" :tempInnerLeft="mainStore.getters.main('Tyre_Temp_FL1')"
              :tempInnerRight="mainStore.getters.main('Tyre_Temp_FL3')"
              :tempLeft="mainStore.getters.main('Tyre_Temp_FL5')"
              :tempRight="mainStore.getters.main('Tyre_Temp_FL7')" />
            <TrackTyre class="tfr" :tempInnerLeft="mainStore.getters.main('Tyre_Temp_FR1')"
              :tempInnerRight="mainStore.getters.main('Tyre_Temp_FR3')"
              :tempLeft="mainStore.getters.main('Tyre_Temp_FR5')"
              :tempRight="mainStore.getters.main('Tyre_Temp_FR7')" />
          </div>

          <div class="tyres">
            <TrackTyre class="trl" :tempInnerLeft="mainStore.getters.main('Tyre_Temp_RL1')"
              :tempInnerRight="mainStore.getters.main('Tyre_Temp_RL3')"
              :tempLeft="mainStore.getters.main('Tyre_Temp_RL5')"
              :tempRight="mainStore.getters.main('Tyre_Temp_RL7')" />
            <TrackTyre class="trr" :tempInnerLeft="mainStore.getters.main('Tyre_Temp_RR1')"
              :tempInnerRight="mainStore.getters.main('Tyre_Temp_RR3')"
              :tempLeft="mainStore.getters.main('Tyre_Temp_RR5')"
              :tempRight="mainStore.getters.main('Tyre_Temp_RR7')" />
          </div>

          <DrsTrack class="twing" :class="getDrsClass" />
        </div>
        <BrakeTempTrack class="tbrake_temp_car" :brakeTempFR="mainStore.getters.main('BreakTempFront')"
          :brakeTempRR="mainStore.getters.main('BreakTempRear')" />

        <div class="ttyretextr">
          <div class="tfrt">
            Front right tyre
            <div class="tfrts1">Sector1: {{ mainStore.getters.main('Tyre_Temp_FR1') }} °C</div>
            <div class="tfrts2">Sector2: {{ mainStore.getters.main('Tyre_Temp_FR3') }} °C</div>
            <div class="tfrts3">Sector3: {{ mainStore.getters.main('Tyre_Temp_FR5') }} °C</div>
            <div class="tfrts4">Sector4: {{ mainStore.getters.main('Tyre_Temp_FR7') }} °C</div>
            <div class="brake_temp_t_fr">Brake temp: {{ mainStore.getters.main('BreakTempFront') }} °C</div>
          </div>
          <div class="trrt">
            Rear right tyre
            <div class="trrts1">Sector1: {{ mainStore.getters.main('Tyre_Temp_RR1') }} °C</div>
            <div class="trrts2">Sector2: {{ mainStore.getters.main('Tyre_Temp_RR3') }} °C</div>
            <div class="trrts3">Sector3: {{ mainStore.getters.main('Tyre_Temp_RR5') }} °C</div>
            <div class="trrts4">Sector4: {{ mainStore.getters.main('Tyre_Temp_RR7') }} °C</div>
            <div class="brake_temp_t_rr">Brake temp: {{ mainStore.getters.main('BreakTempRear') }} °C</div>
          </div>
        </div>
      </div>
      <div class="trackbottomright">
        <div class="tbr">
          <Pedals :th_ped_pos="mainStore.getters.main('Throttle_position')"
            :br_ped_pos="mainStore.getters.main('Front_brake_pressure')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Speedometer from '@/components/Speedometer.vue';
import GForce from '@/components/GForce.vue';
import BrakeTempTrack from '@/components/BrakeTempTrack.vue';
import Pedals from '@/components/Pedals.vue';
import Steering_wheel from '@/components/Steering_wheel.vue';
import TrackTyre from '@/components/TrackTyre.vue';
import { mainStore } from '../utils/telemetryData';
import { computed } from 'vue';
import DrsTrack from '@/components/DrsTrack.vue';

const getDrsClass = computed(()=>{
  return mainStore.getters.main('DRS') === 1 ? "open" : "closed";
})
</script>